export const collectPermissionAndDependents = (
  groups,
  parentId,
  collectedIds
) => {
  if (collectedIds.has(parentId)) return;

  collectedIds.add(parentId);
  groups.forEach((group) => {
    group.permissions.forEach((permission) => {
      if (permission.depends_on === parentId) {
        collectPermissionAndDependents(groups, permission.id, collectedIds);
      }
    });
  });
};

export const applyPermissionEnabled = (groups, permissionId, enabled) => {
  const permissionsToDisable = new Set();

  if (!enabled) {
    collectPermissionAndDependents(groups, permissionId, permissionsToDisable);
  }

  groups.forEach((group) => {
    group.permissions.forEach((permission) => {
      if (permissionsToDisable.has(permission.id)) {
        permission.enabled = false;
        return;
      }

      if (permission.id === permissionId) {
        permission.enabled = enabled;
      }
    });
  });
};

export const toEnabledById = (systems = []) => {
  const enabledById = {};

  systems.forEach(({ id, enabled }) => {
    enabledById[id] = Boolean(enabled);
  });

  return enabledById;
};

export const toCanEditById = (systems = []) => {
  const canEditById = {};

  systems.forEach(({ id, can_edit: canEdit }) => {
    canEditById[id] = canEdit !== false;
  });

  return canEditById;
};

export const isSupervisionSystemUpdating = (updatingIds, systemId) =>
  updatingIds.includes(systemId);

export const removeUpdatingSystem = (updatingIds, systemId) =>
  updatingIds.filter((id) => id !== systemId);
